// src/components/pages/Pessoa/tabs/PessoaTabFuncionarios.jsx

import React from 'react';
import { ThemeProvider } from '@mui/material';
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { Box, Button, Tooltip, IconButton } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';

import DataList from '../../../form/DataList';
import Checkbox from '../../../form/Checkbox';

import { podeEditarItem, podeCancelarItem } from '../../../../hooks/usePermisionMRT';

const PessoaTabFuncionarios = ({ theme, module, mrt }) => {
    const { items, rowCount, isLoading, isRefetching, isError, novoFuncionario, Funcionarios, optionsPessoa } = module.state;
    const { change, focus, blur, limpar, submit, handleEditarOuDeletar } = module.actions;
    const columns = module.columns;

    return (
        <div>
            <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                <DataList
                    text="Funcionário / Colaborador"
                    title="Seleciona a pessoa funcionário / colaborador"
                    name="novoFuncionario.descricao"
                    inputWidth="250px"
                    filteredOptions={optionsPessoa}
                    handleOnChange={change}
                    handleOnFocus={focus}
                    handleOnBlur={blur}
                    value={Funcionarios?.descricao || ''}
                />

                <Checkbox
                    title="Ativo quando marcado"
                    text="Ativo"
                    name="novoFuncionario.ativo"
                    handleOnChange={change}
                    handleOnFocus={focus}
                    handleOnBlur={blur}
                    value={novoFuncionario.ativo}
                    checked={!!novoFuncionario.ativo}
                />

                <Button variant="contained" color="inherit" onClick={limpar} style={{ marginLeft: '10px' }}>
                    Limpar
                </Button>

                <Button
                    variant="contained"
                    color={String(novoFuncionario.funcao).toLowerCase() === 'deletar' ? 'error' : 'info'}
                    onClick={submit}
                    disabled={!novoFuncionario.funcionarioId}
                    style={{ marginLeft: '5px' }}
                >
                    {novoFuncionario.funcao}
                </Button>
            </Box>

            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            muiTableHeadCellProps: { align: 'center' },
                            size: 100,
                        },
                        'mrt-row-numbers': {
                            enableColumnOrdering: true,
                            enableResizing: true,
                            muiTableHeadCellProps: { sx: { fontSize: '1.2rem' } },
                        },
                        'mrt-row-select': {
                            enableColumnActions: false,
                            enableHiding: true,
                            size: 50,
                        },
                    }}
                    enableColumnFilterModes
                    enableGlobalFilterModes
                    enableColumnOrdering
                    enableEditing
                    renderRowActions={({ row }) => (
                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                            <Tooltip arrow placement="left" title="Editar">
                                <span>
                                    <IconButton
                                        onClick={() => handleEditarOuDeletar(row.original, row.index, 'Editar')}
                                        disabled={!podeEditarItem()}
                                    >
                                        <Edit />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip arrow placement="right" title="Deletar">
                                <span>
                                    <IconButton
                                        color="error"
                                        onClick={() => handleEditarOuDeletar(row.original, row.index, 'Deletar')}
                                        disabled={!podeCancelarItem()}
                                    >
                                        <Delete />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Box>
                    )}
                    columns={columns}
                    data={items}
                    rowCount={rowCount}
                    enableRowSelection
                    getRowId={(row) => row.uuid}
                    manualFiltering
                    manualPagination
                    manualSorting
                    muiToolbarAlertBannerProps={isError ? { color: 'error', children: 'Error loading data' } : undefined}
                    onColumnFiltersChange={mrt.setColumnFilters}
                    onColumnFilterFnsChange={mrt.setColumnFiltersMode}
                    onGlobalFilterChange={mrt.setGlobalFilter}
                    onPaginationChange={mrt.setPagination}
                    onSortingChange={mrt.setSorting}
                    initialState={{
                        showColumnFilters: true,
                        density: 'compact',
                    }}
                    state={{
                        columnFilterFns: mrt.columnFilterFns,
                        columnFilters: mrt.columnFilters,
                        globalFilter: mrt.globalFilter,
                        isLoading,
                        pagination: mrt.pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting: mrt.sorting,
                    }}
                    positionExpandColumn="first"
                    positionActionsColumn="first"
                    positionToolbarAlertBanner="bottom"
                    localization={MRT_Localization_PT_BR}
                />
            </ThemeProvider>
        </div>
    );
};

export default React.memo(PessoaTabFuncionarios);
